const NOTICE_SHOW_CONTACT = 'libs.constants.noticeMessage.noticeShowContact';

export const APP = {
  account: 'account',
  direct: 'direct',
  muse: 'muse',
  ms: 'meditationstudio'
};

export const APP_PLATFORM = {
  web: 'web',
  windows: 'windows',
  android: 'android'
};

export const IMAGE_PATHS = {
  authWidgetLogo: '/images/logo/Muse_Account_Logo.png',
  defaultHeaderLayout: {
    desktopAppLogo: '/images/logo/Muse_Account_Logo.png',
    mobileAppLogo: '/images/logo/Muse_Account_Logo_mobile.png',
    profileIcon: '/images/ProfileIcon.png'
  },
  HeaderLayoutMs: {
    desktopAppLogo: '/images/logo/MSbyMuseLogo.png',
    mobileAppLogo: '/images/logo/MSbyMuseLogo.png',
    profileIcon: '/images/Profile_Icon_Grey.png'
  }
};

export const RESPONSE_KEYS_MAP = {
  email: 'Email',
  password: 'Password'
};

export const NOTICE_MESSAGES = {
  showContact: NOTICE_SHOW_CONTACT,
  general: 'libs.constants.noticeMessage.general'
};

export const SESSION_TIMEOUT = {
  notificationMsg: 'libs.constants.sessionTimeout.notificationMessage',
  idleTime: 600000
};

export const AUTH_NOTIFICATION_MESSAGE = 'libs.constants.auth.notificationMessage';

export const SUBSCRIPTION_ACTIVATE_EVENT_CONFIG = {
  event_category: 'subscription-activation',
  event_label: 'form-abandonment-tracking',
};

export const SUBSCRIPTION_ACTIVATE_EVENT_FIELD_CONST = {
  ACTIVATION_CODE_DETAILS_ACTIVATION_CODE: 'activation_code',
  ACCOUNT_DETAILS_EMAIL: 'email',
  ACCOUNT_DETAILS_PASSWORD: 'password',
  ACCOUNT_DETAILS_FIRST_NAME: 'given_name',
  ACCOUNT_DETAILS_LAST_NAME: 'family_name',
  ACCOUNT_DETAILS_BIRTHDATE: 'birthdate',
  ADDRESS_DETAILS_FIRST_NAME: 'first_name',
  ADDRESS_DETAILS_LAST_NAME: 'last_name',
  ADDRESS_DETAILS_ADDRESS: 'address',
  ADDRESS_DETAILS_EXTENDED_ADDRESS: 'extended_address',
  ADDRESS_DETAILS_CITY: 'city',
  ADDRESS_DETAILS_COUNTRY: 'user_country',
  ADDRESS_DETAILS_REGION: 'region',
  ADDRESS_DETAILS_ZIP_CODE: 'zip_code',
  ADDRESS_DETAILS_PHONE_NUMBER: 'phone_number',
  PAYMENT_FULL_NAME: 'full_name',
  PAYMENT_CARD_NUMBER: 'number',
  PAYMENT_EXPIRY: 'expiry',
  PAYMENT_CVV: 'cvv'
};

export const EVENTS_CONST = {
  changeEmail: 'change_email',
  changePassword: 'change_password',
  logInApp: 'log_in_app',
  clickSignOutApp: 'click_sign_out_app',
  clickMenuContactUs: 'click_menu_contact_us',
  clickMenuSettings: 'click_menu_settings',
  clickMenuDataPolicy: 'click_menu_data_policy',
  clickDataPolicyDeleteAccount: 'click_data_policy_delete_account',
  clickConfirmDeleteAccount: 'click_confirm_delete_account',
  deleteAccountSuccess: 'delete_account_success',
  checkoutMusePlans: 'checkout_muse_plans',
  clickMusePlansTos: 'click_muse_plans_tos',
  clickMusePlansBillingInvoicesLink: 'click_muse_plans_billing_invoices_link',
  clickMusePlansContactus: 'click_muse_plans_contactus',
  checkoutMuseTrialPlans: 'checkout_muse_trial_plans',
  clickMuseTrialPlansTos: 'click_muse_trial_plans_tos',
  clickMuseTrialPlansContactus: 'click_muse_trial_plans_contactus',
  checkoutMuseAndroidPromoPlans: 'checkout_muse_android_promo_plans',
  clickMuseAndroidPromoPlansTos: 'click_muse_android_promo_plans_tos',
  clickMuseAndroidPromoPlansContactus: 'click_muse_android_promo_plans_contactus',
  checkoutMsPlans: 'checkout_ms_plans',
  clickMsPlansTos: 'click_ms_plans_tos',
  clickMsPlansBillingInvoicesLink: 'click_ms_plans_billing_invoices_link',
  clickMsPlansContactus: 'click_ms_plans_contactus',
  checkoutMuseDirectPlansAndroid: 'checkout_muse_direct_plans_android',
  clickMuseDirectPlansAndroidTos: 'click_muse_direct_plans_android_tos',
  clickMuseDirectPlansAndroidBillingInvoicesLink: 'click_muse_direct_plans_android_billing_invoices_link',
  clickMuseDirectPlansAndroidContactus: 'click_muse_direct_plans_android_contactus',
  checkoutMuseDirectPlansWindows: 'checkout_muse_direct_plans_windows',
  clickMuseDirectPlansWindowsTos: 'click_muse_direct_plans_windows_tos',
  clickMuseDirectPlansWindowsBillingInvoicesLink: 'click_muse_direct_plans_windows_billing_invoices_link',
  clickMuseDirectPlansWindowsContactus: 'click_muse_direct_plans_windows_contactus',
  activationCodeDetailsActivationCodeFilled: 'activation_code_details_activation_code_filled',
  accountDetailsFirstNameFilled: 'account_details_first_name_filled',
  accountDetailsLastNameFilled: 'account_details_last_name_filled',
  accountDetailsEmailFilled: 'account_details_email_filled',
  accountDetailsPasswordFilled: 'account_details_password_filled',
  accountDetailsDOBFilled: 'account_details_dob_filled',
  addressDetailsFirstNameFilled: 'address_details_first_name_filled',
  addressDetailsLastNameFilled: 'address_details_last_name_filled',
  addressDetailsAddressFilled: 'address_details_address_filled',
  addressDetailsApartmentFilled: 'address_details_apartment_filled',
  addressDetailsCityFilled: 'address_details_city_filled',
  addressDetailsCountryFilled: 'address_details_country_filled',
  addressDetailsRegionFilled: 'address_details_region_filled',
  addressDetailsZipCodeFilled: 'address_details_zip_code_filled',
  addressDetailsPhoneNumberFilled: 'address_details_phone_number_filled',
  paymentDetailsCardNumberFilled: 'payment_details_card_number_filled',
  paymentDetailsFullNameFilled: 'payment_details_full_name_filled',
  paymentDetailsCardExpiryFilled: 'payment_details_card_expiry_filled',
  paymentDetailsCardCVVFilled: 'payment_details_card_cvv_filled',
  addressDetailsContinueSubmitted: 'address_details_continue_submitted',
  paymentDetailsActivateNowSubmitted: 'payment_details_activate_now_submitted'
};

export const SUPPORTED_LANGUAGES = ['en', 'es', 'de', 'ja', 'fr'];

export default {
  IMAGE_PATHS,
  RESPONSE_KEYS_MAP,
  NOTICE_MESSAGES,
  APP,
  APP_PLATFORM,
  EVENTS_CONST,
  AUTH_NOTIFICATION_MESSAGE,
  SUPPORTED_LANGUAGES
};



// WEBPACK FOOTER //
// ./src/libs/constants.js